import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import Navbar from "../Components/Navbar";
import Copyright from "../Components/Copyright";

const PURPLE = "rgb(109, 79, 160)";
const BORDER = "#C5A7CF";

const cardSx = {
  width: { md: "520px", xs: "auto" },
  margin: "5rem auto 2rem",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "2.5rem 2rem",
  textAlign: "center",
  boxShadow: "rgb(146, 141, 191) 0px 2px 12px",
  gap: "1.5rem",
};

const btnSx = {
  fontFamily: "ABLE",
  fontSize: "17px !important",
  lineHeight: "initial !important",
  p: "0.65rem 2rem",
  border: `2px solid ${BORDER} !important`,
  borderRadius: "8px",
  minWidth: "130px",
};

const DisableNotification = () => {
  const { id } = useParams();

  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [userError, setUserError] = useState(false);

  const [status, setStatus] = useState("confirm"); // "confirm" | "loading" | "success" | "cancelled" | "error"
// console.log(status);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}/get/capno/user/by/${id}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setUser(data.data);
          console.log(data.data);
          
          if (data.data?.disable_renewal_notificatin === 1) {
            setStatus("already_disabled");
          }
        } else {
          setUserError(true);
        }
      })
      .catch(() => setUserError(true))
      .finally(() => setLoadingUser(false));
  }, [id]);

  const handleYes = async () => {
    setStatus("loading");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}/disable/renewal/${id}`
      );
      const data = await res.json();
      if (data.success) {
        setStatus("success");
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  const handleNo = () => setStatus("cancelled");

  if (loadingUser) {
    return (
      <Container>
        {/* <Navbar /> */}
        <Box sx={{ ...cardSx, py: "4rem" }}>
          <CircularProgress sx={{ color: PURPLE }} />
        </Box>
        {/* <Box sx={{ pt: { sm: "10rem", xs: "5rem" } }}>
          <Copyright />
        </Box> */}
      </Container>
    );
  }

  if (userError) {
    return (
      <Container>
        {/* <Navbar /> */}
        <Box sx={cardSx}>
          <Typography variant="h6" sx={{ color: "#c62828", fontFamily: "ABLE" }}>
            User not found or link is invalid.
          </Typography>
        </Box>
        {/* <Box sx={{ pt: { sm: "10rem", xs: "5rem" } }}>
          <Copyright />
        </Box> */}
      </Container>
    );
  }

  return (
    <Container>
      {/* <Navbar /> */}

      <Box sx={cardSx}>
        {/* ALREADY DISABLED */}
        {status === "already_disabled" && (
          <>
            <CheckCircleOutlineIcon sx={{ color: "#4caf50", fontSize: 72 }} />
            <Typography
              variant="h5"
              sx={{ color: PURPLE, fontFamily: "ABLE", fontWeight: 600 }}
            >
              Already Disabled
            </Typography>
            {user?.firstname && (
              <Typography sx={{ color: "#555", fontFamily: "ABLE" }}>
                Hi <strong>{user.firstname} {user.lastname}</strong>,
              </Typography>
            )}
            <Typography sx={{ color: "#555", fontFamily: "ABLE", fontSize: "1.05rem" }}>
              Renewal email notifications are already disabled for your account.
              <br />
              No further action is needed.
            </Typography>
          </>
        )}

        {/* CONFIRM */}
        {status === "confirm" && (
          <>
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "#f3eeff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <UnsubscribeIcon sx={{ color: PURPLE, fontSize: 40 }} />
            </Box>

            <Typography
              variant="h5"
              sx={{ color: PURPLE, fontFamily: "ABLE", fontWeight: 600 }}
            >
              Disable Renewal Notification Emails
            </Typography>

            {user?.firstname && (
              <Typography sx={{ color: "#555", fontFamily: "ABLE" }}>
                Hi <strong>{user.firstname} {user.lastname}</strong>,
              </Typography>
            )}

            <Typography sx={{ color: "#555", fontFamily: "ABLE", fontSize: "1.05rem" }}>
              Do you want to disable renewal email notifications for your account?
            </Typography>

            <Box sx={{ display: "flex", gap: "1rem", mt: "0.5rem", flexWrap: "wrap", justifyContent: "center" }}>
              <Button
                onClick={handleYes}
                sx={{
                  ...btnSx,
                  background: `${PURPLE} !important`,
                  color: "#fff !important",
                  "&:hover": { background: "#6a4a9a !important" },
                }}
              >
                Yes, Disable
              </Button>
              <Button
                onClick={handleNo}
                sx={{
                  ...btnSx,
                  background: "#fff !important",
                  color: `${PURPLE} !important`,
                  "&:hover": { background: "#f3eeff !important" },
                }}
              >
                No, Keep
              </Button>
            </Box>
          </>
        )}

        {/* LOADING */}
        {status === "loading" && (
          <>
            <CircularProgress sx={{ color: PURPLE }} />
            <Typography sx={{ color: "#555", fontFamily: "ABLE" }}>
              Processing your request…
            </Typography>
          </>
        )}

        {/* SUCCESS */}
        {status === "success" && (
          <>
            <CheckCircleOutlineIcon sx={{ color: "#4caf50", fontSize: 72 }} />
            <Typography
              variant="h5"
              sx={{ color: PURPLE, fontFamily: "ABLE", fontWeight: 600 }}
            >
              Email Notifications Disabled
            </Typography>
            <Typography sx={{ color: "#555", fontFamily: "ABLE", fontSize: "1.05rem" }}>
              You have successfully disabled renewal email notifications.
              <br />
              You will no longer receive renewal reminder emails.
            </Typography>
          </>
        )}

        {/* CANCELLED */}
        {status === "cancelled" && (
          <>
            <Box
              sx={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "#f3eeff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <UnsubscribeIcon sx={{ color: PURPLE, fontSize: 40 }} />
            </Box>
            <Typography
              variant="h5"
              sx={{ color: PURPLE, fontFamily: "ABLE", fontWeight: 600 }}
            >
              No Changes Made
            </Typography>
            <Typography sx={{ color: "#555", fontFamily: "ABLE", fontSize: "1.05rem" }}>
              Your renewal email notifications remain active.
            </Typography>
          </>
        )}

        {/* ERROR */}
        {status === "error" && (
          <>
            <Typography
              variant="h6"
              sx={{ color: "#c62828", fontFamily: "ABLE" }}
            >
              Something went wrong. Please try again later.
            </Typography>
            <Button
              onClick={() => setStatus("confirm")}
              sx={{
                ...btnSx,
                background: `${PURPLE} !important`,
                color: "#fff !important",
              }}
            >
              Retry
            </Button>
          </>
        )}
      </Box>

      {/* <Box sx={{ pt: { sm: "10rem", xs: "5rem" } }}>
        <Copyright />
      </Box> */}
    </Container>
  );
};

export default DisableNotification;
